<template>
  <VForm :form="form" @submit="onSubmit">
    <VMulticheckbox name="text_to_be_confirmed" :hint="$t('substore.text_to_be_confirmed_hint')" required />

    <slot />
  </VForm>
</template>

<script>
import Form from '@/components/Form/Form';
import MultiCheckbox from '@/components/Form/MultiCheckbox';
import { initFields } from '@/utils/form';

export default {
  name: 'ProductAdministrationSummaryForm',

  components: {
    VForm: Form,
    VMulticheckbox: MultiCheckbox,
  },

  props: {
    textLists: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: initFields({
        name: 'text_to_be_confirmed',
        isHidden: !this.textLists.textToBeConfirmedAdministrationSummary || this.textLists.textToBeConfirmedAdministrationSummary.length === 0,
        items: this.textLists.textToBeConfirmedAdministrationSummary,
      }),
      rescissionLong: false,
    };
  },

  methods: {
    onSubmit({ values }) {
      this.$emit('submit', values);
    },
  },
};
</script>

<style scoped>
.button-bar > span {
  position: relative;
  top: 1px;
  display: inline-block;
}
</style>
